import React, { useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import styles from "styles/component/Popper.module.scss";
import asset from "json/assets";


export const DefaultPopUp = (props) => {
  const {
    errorMsg,
    handleSave,
    handleClose
  } = props;

  const getErrorMsgComponent = () => {
    return (
      <Box className={styles.errorBox}>
        <Grid container>
          <Grid item xs={2} md={2}>
            <img src={asset.update} alt="#Info" />
          </Grid>
          <Grid item xs={6} md={10}>
            {errorMsg}
          </Grid>
        </Grid>
      </Box>
    );
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        handleSave();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleSave]);

  return (
    <Box className={styles.popover_body_new}>

          {errorMsg && getErrorMsgComponent()}
          <Box className={styles.popover_ftr}>
        <Typography className={styles.defaultPopupText}>
        Save changes to this item?
          </Typography>

    <Box className={styles.defaultPopupBtnGroup}>
            <Button
              to={"#"}
              className={styles.blue_btn}
              onClick={() => handleSave()}
            >
              Yes
            </Button>
            <Button
              to={"#"}
              className={styles.blue_btn}
              onClick={() => handleClose()}
            >
              No
            </Button>

    </Box>
          </Box>
        </Box>
  );
};
